import { render, staticRenderFns } from "./TalentPeople.vue?vue&type=template&id=43ff9d92&scoped=true&"
import script from "./TalentPeople.vue?vue&type=script&lang=js&"
export * from "./TalentPeople.vue?vue&type=script&lang=js&"
import style0 from "./TalentPeople.vue?vue&type=style&index=0&id=43ff9d92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ff9d92",
  null
  
)

export default component.exports